import { render, staticRenderFns } from "./ValidationProvider.vue?vue&type=template&id=571f0ff0&"
import script from "./ValidationProvider.vue?vue&type=script&lang=ts&"
export * from "./ValidationProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports